export function login(email, password, remember)
{
    return axios.get('/sanctum/csrf-cookie').then(response => {
        return axios.post(route('app.login'), {
            email,
            password,
            ...(remember ? {remember: true} : {})
        });
    });
}

export function twoFactorAuth(data) {
    return axios.post(route('app.two-factor-auth'), data);
}

export function twoFactorVerify(data) {
    return axios.post(route('app.two-factor-verify'), data);
}

export function validateCompany(data) {
    return axios.post(route('api.manage.register.validate'), data).then((response) => {
        return response.data;
    })
}

export function register(data) {
    return axios.post(route('api.manage.register'), data).then((response) => {
        return response.data;
    });
}

export function requestResetLink(email) {
    return axios.post(route('app.request-reset'), {
        email,
    }).then(response => response.data);
}

//update password while logged in
export function updatePassword(userId, data)
{
    return axios.patch(
        route('api.manage.users.passwordUpdate', { userId: userId }), data)
        .then(response => response.data);
}

//reset password while not logged in
export function resetPassword(email, password, password_confirmation, token, isNewUser) {
    const passwordResetRoute = isNewUser ? route("app.user-reset-password") : route("app.reset-password");
    return axios
        .post(passwordResetRoute, {
            email,
            password,
            password_confirmation,
            token,
        })
        .then((response) => response.data);
}

export function logout()
{
    return axios.post(route('app.logout'))
        .then(response => {
            return response.data;
        });
}

export function index(extraIncludes)
{
    let include = '?limit=999&include=userPermissions,companyUsers.role.permissions' + (extraIncludes ? "," + extraIncludes : "");

    return axios.get(route('api.manage.companies.users') + include)
        .then(response => response.data);
}

export function findForInvite (email)
{
    return axios.get(route('api.manage.companies.users.findForInvite') + '?filter[email]=' + email)
        .then(response => response.data);
}

export function store(data)
{
    return axios.post(route('api.manage.companies.users'), data)
        .then(response => response.data);
}

export function update(userId, data) {
    return axios.patch(route('api.manage.users.update', { userId: userId }), data)
        .then(response => response.data);
}

export function show (userId, companyId = null, include = [])
{
    if (include.length) {
        include = include.join();
    }
    let params = { userId: userId };

    if (companyId) {
        params.companyId = companyId;
    }

    return axios.get(route('api.manage.users.show', params) + '?include=' + include);
}

export function permissions (params)
{
    return axios.get(route('api.manage.users.permissions.list', params)).then(response => response.data);
}


export function updateFavorite(userId, applicationId) {
    return axios.post(route('api.manage.companies.users.favorite', {applicationId}))
        .then(response => response.data);
}
